/**
 * The provider settings sections, each of which is its own sub-page under
 * `/setting/shipping-providers/:providerName/:country/<slug>`.
 *
 * The value IS the URL slug — keep them in sync with the child routes registered in `routes.tsx`.
 */
export enum ProviderSettingsSection {
    Connection = 'connect',
    GeneralSettings = 'general',
    SenderDetails = 'sender',
    Shipping = 'shipping',
    PickupPoint = 'pickup-points',
    HomeDelivery = 'home-delivery',
    Rules = 'rules',
    OrderAttributes = 'order-attributes',
    /** Aggregators only: the carriers offered through the aggregator. */
    ServiceProviders = 'service-providers',
}
